import type * as type from "@vTypes";
import {
  ShiftCodeFormDialog,
  type ShiftCodeFormSubmitValue,
} from "./ShiftCodeFormDialog";
import {
  isSameShiftManage,
  nextShiftManage,
} from "./shift-code-add-dialog-utils";

function ConfTableAddRow({
  setAddNewShifts,
  addShift,
  currentShiftManage,
  saveShiftManage,
  shiftIdFlatMap,
  offSwapOffShiftGb,
  isPending = false,
}: {
  readonly setAddNewShifts: (value: boolean) => void;
  readonly addShift: (value: type.AddShift) => void;
  readonly currentShiftManage: type.ShiftManageObject[];
  readonly saveShiftManage: (value: type.ShiftManageObject[]) => void;
  readonly shiftIdFlatMap: readonly string[];
  readonly offSwapOffShiftGb?: string | null;
  readonly isPending?: boolean;
}) {
  const handleSubmit = (value: ShiftCodeFormSubmitValue) => {
    const shiftManage = nextShiftManage(
      currentShiftManage,
      value.shift_id,
      value.slotIndex
    );

    addShift({
      shift_id: value.shift_id,
      name: value.name,
      description: value.description,
      color: value.color,
      start_time: value.start_time,
      end_time: value.end_time,
      type: value.type,
      shift_gb: value.shift_gb,
      show_in_preference: value.show_in_preference,
      off_swap_target: value.off_swap_target,
      health_leave_target: value.health_leave_target,
      sleep_off_target: value.sleep_off_target,
    });

    if (!isSameShiftManage(currentShiftManage, shiftManage)) {
      saveShiftManage(shiftManage);
    }
    setAddNewShifts(false);
  };

  return (
    <ShiftCodeFormDialog
      open
      mode="add"
      title="근무코드 추가"
      description="근무표에 사용할 코드와 타입별 조건을 설정합니다."
      initialValue={{
        shift_id: "",
        name: "",
        description: "",
        color: "#000000",
        start_time: "00:00",
        end_time: "23:59",
        type: "근무",
        shift_gb: null,
        show_in_preference: false,
        off_swap_target: false,
        health_leave_target: false,
        sleep_off_target: false,
      }}
      initialSlotIndex={0}
      duplicateShiftIds={shiftIdFlatMap}
      offSwapEditable
      offSwapOffShiftGb={offSwapOffShiftGb}
      isPending={isPending}
      onOpenChange={(open) => {
        if (!open && !isPending) {
          setAddNewShifts(false);
        }
      }}
      onSubmit={handleSubmit}
    />
  );
}

export default ConfTableAddRow;
